import { config } from 'src/config/config';
import { languages } from 'src/config/i18n.config.mjs';

export const LANGUAGE_PREFERENCE_STORAGE_KEY = 'languagePreference';

const availableLanguages = Object.values(languages ?? {});

const getLanguageByLocale = (locale?: string) => {
    return locale && languages[locale];
};

const isLanguageAvailable = (language: string) => {
    return availableLanguages.includes(language);
};

const getBrowserLanguage = () => navigator.language;

const saveLanguagePreferenceToLocalStorage = (language: string) => {
    localStorage.setItem(LANGUAGE_PREFERENCE_STORAGE_KEY, language);

    return language;
};

const getLanguagePreferenceFromLocalStorage = () => {
    return localStorage.getItem(LANGUAGE_PREFERENCE_STORAGE_KEY);
};

export const getPreferredLanguage = (localePreference?: string) => {
    if (localePreference) {
        const languagePreference = getLanguageByLocale(localePreference);

        if (languagePreference) {
            return saveLanguagePreferenceToLocalStorage(languagePreference);
        }

        return saveLanguagePreferenceToLocalStorage(config.defaultLanguage);
    } else {
        const savedLanguageFromLocalStorage = getLanguagePreferenceFromLocalStorage();
        if (savedLanguageFromLocalStorage && isLanguageAvailable(savedLanguageFromLocalStorage)) {
            return savedLanguageFromLocalStorage;
        }

        let browserLanguage = getBrowserLanguage();
        if (browserLanguage == 'zh-CN') {
            browserLanguage = 'zh-Hans';
        }

        if (browserLanguage == 'fr-FR') {
            browserLanguage = 'fr';
        }

        if (isLanguageAvailable(browserLanguage)) {
            return saveLanguagePreferenceToLocalStorage(browserLanguage);
        }

        return saveLanguagePreferenceToLocalStorage(config.defaultLanguage);
    }
};
